import { Icon, TextInput } from '@repo/foundations';
import type { ChangeEvent } from 'react';
import { useStyles } from './EntityNodeChildrenSearch.styles';

interface EntityChildrenSearchProps {
	term: string;
	setTerm: (value: string | ChangeEvent<any> | null | undefined) => void;
}

function EntityChildrenSearch({ term, setTerm }: EntityChildrenSearchProps) {
	const { classes } = useStyles();
	return (
		<TextInput
			classNames={classes}
			placeholder="Search children..."
			icon={<Icon name="search" color="icon/secondary/default" />}
			value={term}
			onChange={setTerm}
		/>
	);
}

export default EntityChildrenSearch;
